import { render, staticRenderFns } from "./ViewGatCodeEditor.vue?vue&type=template&id=09841b4c&scoped=true&"
import script from "./ViewGatCodeEditor.vue?vue&type=script&lang=js&"
export * from "./ViewGatCodeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09841b4c",
  null
  
)

export default component.exports